var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile is-centered"},[_c('div',{staticClass:"column is-half"},[_c('p',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.$t('user.confirm', { email: _vm.email }))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }